import { Box, Button, Flex, Image, Text } from "@chakra-ui/react";
import { useState, useEffect } from "react";
import { BiChevronRight } from "react-icons/bi"
import { BiChevronLeft } from "react-icons/bi"



const images = [
  "https://wallpapercave.com/wp/wp10076384.jpg",
  "https://wallpapercave.com/wp/wp7101027.jpg",
  "https://www.itl.cat/pngfile/big/17-177929_urvashi-rautela-sexy-high-definition-wallpapers-sexy-urvashi.jpg",
  "https://w0.peakpx.com/wallpaper/377/508/HD-wallpaper-beautiful-girl-model-is-wearing-white-dress-and-black-hat-girls.jpg",
  "https://wallpaper-house.com/data/out/10/wallpaper2you_412297.jpg"
];

function ImageSlider() {
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const previousImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  const nextImage = () => {
    setCurrentImageIndex((prevIndex) =>
      prevIndex === images.length - 1 ? 0 : prevIndex + 1
    );
  };

  useEffect(() => {
    const interval = setInterval(nextImage, 3000);

    return () => {
      clearInterval(interval);
    };
  }, []);

  return (
    <Box w="80%" h="100%"  m="auto" mt={"20px"}  >
      <Flex align="center" justify="space-between" position={"relative"}>
        <Button onClick={previousImage} z-index={"1"} pos={"absolute"} left={"10px"} bg={"none"} _hover={{w:"100px",bg:"green.100"}}><BiChevronLeft _hover={{w:"30%"}} h="100%"/></Button>
        <Image src={images[currentImageIndex]} alt="Slider Image"  w={"100%"} h="80vh"/>
        <Button onClick={nextImage}  z-index={"1"}  pos={"absolute"} right={"10px"} bg={"none"} _hover={{w:"100px",bg:"green.100"}}><BiChevronRight w={"max"} h="100%"/></Button>
      </Flex>
      <Flex justify="center" mt={4}>
        {images.map((_, index) => (
          <Box
            key={index}
            w={4}
            h={4}
            borderRadius="full"
            bg={index === currentImageIndex ? "blue.500" : "gray.500"}
            mx={1}
            cursor="pointer"
            onClick={() => setCurrentImageIndex(index)}
          />
        ))}
      </Flex>
      {/* <Text textAlign="center" mt={2}>
        Image {currentImageIndex + 1} of {images.length}
      </Text> */}
    </Box>
  );
}

export default ImageSlider;